import { render, staticRenderFns } from "./local-case-types-modal-basic-form.vue?vue&type=template&id=2e1ae5b5&scoped=true&"
import script from "./local-case-types-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./local-case-types-modal-basic-form.ts?vue&type=script&lang=ts&"
import style0 from "./local-case-types-modal-basic-form.scss?vue&type=style&index=0&id=2e1ae5b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1ae5b5",
  null
  
)

export default component.exports